import 'source-map-support/register';
import { green } from 'chalk';

import './parse';
import './formatDates';
import './repetition';

console.log(green.underline.bold('\t\tAll tests passed.\n'));
